'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useMemo } from 'react';
import LogoIcon from '../Images/LogoIcon/index.js';
import PauseIcon from '../Images/PauseIcon/index.js';
import PlayIcon from '../Images/PlayIcon/index.js';
import { ELanguage, EAppMode } from '../Utils/constants.js';
import { STContainer, STImage, STContent, STControl, STRange, STPlay, STLogo } from './styles.js';
import { EType, ReactPlayer } from './types.js';

var Podcast = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? EType.LARGE : _b, _c = _a.language, language = _c === void 0 ? ELanguage.EN : _c, appMode = _a.appMode, podcastData = _a.podcastData;
    var _d = useState(0), duration = _d[0], setDuration = _d[1];
    var _e = useState({
        playing: false,
        playEnd: false,
        prePlayed: 0,
        prePercent: null
    }), play = _e[0], setPlay = _e[1];
    var _f = useState({
        played: 0,
        playedSeconds: 0,
        loaded: 0,
        loadedSeconds: 0
    }), progress = _f[0], setProgress = _f[1];
    var domainImage = appMode !== EAppMode.production
        ? "https://".concat(appMode, "-images03.vietnamworks.com")
        : 'https://images03.vietnamworks.com';
    var podcast = podcastData || {
        title: 'Muốn phát triển sự nghiệp đừng ngại hỏi Sếp 5 điều này',
        time: language === ELanguage.EN ? 'Apr 7' : '7 tháng 4',
        image: "".concat(domainImage, "/podcast/images/PTSN-300x300.png"),
        url: 'https://www.vietnamworks.com/hrinsider/podcast',
        utm: 'utm_source_navi=banner&utm_medium_navi=PODCASTTRAFFIC&utm_campaign_navi=HRINSIDER2023',
        link: 'https://www.buzzsprout.com/1954516/12606850-mu-n-phat-tri-n-s-nghi-p-d-ng-ng-i-h-i-s-p-5-di-u-nay.mp3'
    };
    var sizePlayer = {
        large: {
            fontSize: 14,
            height: 80,
            playIconSize: 32,
            imageSize: 64
        },
        medium: {
            fontSize: 18,
            height: 352,
            playIconSize: 48,
            imageSize: 176
        },
        small: {
            fontSize: 16,
            height: 192,
            playIconSize: 32,
            imageSize: 90
        }
    };
    var handlePlay = function () {
        if (play.playEnd) {
            setPlay(function (play) { return (__assign(__assign({}, play), { playEnd: false })); });
        }
        setPlay(function (play) { return (__assign(__assign({}, play), { playing: !play.playing })); });
    };
    var handlePlayEnd = function () { return setPlay(function (play) { return (__assign(__assign({}, play), { playing: false, playEnd: true })); }); };
    var handleChangePlayed = function (event) {
        var _a;
        var percent = event.target.valueAsNumber / 100;
        setProgress(function (prev) { return (__assign(__assign({}, prev), { played: percent })); });
        (_a = play.player) === null || _a === void 0 ? void 0 : _a.seekTo(duration * percent);
    };
    var handleMouseMove = function (event) {
        var percent = ((event.nativeEvent.offsetX / event.target.clientWidth) *
            parseInt(event.target.getAttribute('max'), 10)) /
            100;
        var prePlayed = duration * percent;
        if (prePlayed < 0)
            return;
        setPlay(function (play) { return (__assign(__assign({}, play), { prePlayed: Math.ceil(prePlayed), prePercent: percent * 100 })); });
    };
    var handleFormatTime = function (time, isTooltip) {
        return ((time && progress.played && !isTooltip ? '-' : '') +
            '0' +
            Math.floor(time / 60) +
            ':' +
            ('0' + Math.floor(time % 60)).slice(-2));
    };
    var handleRedirectToHRinsiderPodcast = function () {
        return window.open("".concat(podcast.url, "?").concat(podcast.utm));
    };
    var played = useMemo(function () { return Math.ceil(progress.played * 100); }, [progress.played]);
    return (React__default.createElement(STContainer, __assign({}, sizePlayer[type], { type: type }),
        React__default.createElement(ReactPlayer, { ref: ref, width: 0, height: 0, playing: play.playing, url: podcast.link, onReady: function (_player) { return setPlay(function (play) { return (__assign(__assign({}, play), { player: _player })); }); }, onDuration: function (_duration) { return setDuration(Math.floor(_duration)); }, onProgress: function (_progress) {
                return setProgress(__assign(__assign({}, _progress), { playedSeconds: Math.floor(_progress.playedSeconds), loadedSeconds: Math.floor(_progress.loadedSeconds) }));
            }, onEnded: handlePlayEnd, config: {
                file: {
                    attributes: {
                        preload: 'auto'
                    },
                    forceAudio: true
                }
            } }),
        React__default.createElement(STImage, __assign({}, sizePlayer[type], { onClick: handleRedirectToHRinsiderPodcast }),
            React__default.createElement("img", { src: podcast.image, alt: 'image' })),
        React__default.createElement(STContent, __assign({}, sizePlayer[type], { type: type }),
            React__default.createElement("p", { className: 'title', onClick: handleRedirectToHRinsiderPodcast }, podcast.title),
            React__default.createElement("div", { className: 'info' },
                React__default.createElement("div", null, podcast.time),
                React__default.createElement("div", null, " . "),
                React__default.createElement("div", { onClick: handleRedirectToHRinsiderPodcast }, "VietnamWorks")),
            React__default.createElement(STControl, __assign({}, sizePlayer[type]),
                React__default.createElement(STRange, { style: {
                        backgroundSize: "".concat(played, "% 100%")
                    }, type: 'range', min: 0, max: 100, value: played, prePlayed: handleFormatTime(play.prePlayed, true), prePercent: play.prePercent, onChange: handleChangePlayed, onClick: function (e) { return e.stopPropagation(); }, onMouseMove: handleMouseMove, onMouseLeave: function () {
                        return play.prePlayed &&
                            setPlay(function (play) { return (__assign(__assign({}, play), { prePlayed: 0, prePercent: null })); });
                    }, "aria-label": podcast.title }),
                React__default.createElement("div", null, handleFormatTime(duration - progress.playedSeconds)),
                React__default.createElement(STPlay, __assign({ onClick: handlePlay, className: 'Homepage_Podcast' }, sizePlayer[type]), play.playing ? React__default.createElement(PauseIcon, { language: language }) : React__default.createElement(PlayIcon, { language: language })))),
        React__default.createElement(STLogo, { onClick: handleRedirectToHRinsiderPodcast },
            React__default.createElement(LogoIcon, null))));
});

export { Podcast as default };
//# sourceMappingURL=index.js.map
